import { useEffect } from 'react';

/**
 * Marks `<html data-prerender-ready="true">` when async route data + SEO have settled.
 * Post-build Puppeteer waits for this before saving HTML snapshots.
 */
export function usePrerenderReady(isReady) {
  useEffect(() => {
    const el = document.documentElement;
    if (isReady) {
      el.setAttribute('data-prerender-ready', 'true');
      return () => {
        el.removeAttribute('data-prerender-ready');
      };
    }
    el.removeAttribute('data-prerender-ready');
    return undefined;
  }, [isReady]);
}
